import * as React from 'react'
import * as PropTypes from 'prop-types'
import { defineMessages, FormattedMessage } from 'react-intl'

import { Theme } from '../../theme'

import { Media, MediaImg, MediaBody } from '../media'
import { Modal, ModalContent, ModalFooter } from '../modal'
import { Button } from '../button'

import Info from './info.svg'

const messages = defineMessages({
  cancelButton: {
    id: 'ui-kit.confirm-dialog.cancel',
    defaultMessage: 'Cancel',
  },
  confirmButton: {
    id: 'ui-kit.confirm-dialog.ok',
    defaultMessage: 'Ok',
  },
})

interface IConfirmDialogProps {
  onClose: () => void
  onConfirm: () => void
  message: React.ReactNode
  continueLabel?: React.ReactNode
  abortLabel?: React.ReactNode
  variant: 'negative' | 'positive'
}

export class ConfirmDialog extends React.Component<IConfirmDialogProps> {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    continueLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    abortLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    variant: PropTypes.oneOf(['negative', 'positive']),
  }

  handleSubmit = () => {
    this.props.onConfirm()
    this.props.onClose()
  }

  render() {
    const { onClose, variant = 'positive' } = this.props

    return (
      <Theme>
        {theme => (
          <Modal style={{ width: '460px', maxWidth: '100vw' }}>
            <ModalContent>
              <Media>
                <MediaImg>
                  <Info />
                </MediaImg>
                <MediaBody>{this.props.message}</MediaBody>
              </Media>
            </ModalContent>
            <ModalFooter tight>
              <Button
                flush
                onClick={onClose}
                size="small"
                style={{ marginRight: theme.settings.spacing.small }}
                variant="secondary"
              >
                {this.props.abortLabel || <FormattedMessage {...messages.cancelButton} />}
              </Button>
              <Button flush onClick={this.handleSubmit} size="small" variant={variant}>
                {this.props.continueLabel || <FormattedMessage {...messages.confirmButton} />}
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Theme>
    )
  }
}
